import { IconActionPlus16, IconActionPlus24 } from '@cian/ui-kit-design-tokens/icons';
import * as style from './style.css';
import React from 'react';
import { UIHeading4 } from '@cian/ui-kit';
import clsx from 'clsx';

const ADD_NEW_BUILDING_TO_COMPARE = '/novostroyki/';

export interface IAddButtonProps {
  floating?: boolean;
  onClick: () => void;
}

export function AddButton({ floating = false, onClick }: IAddButtonProps) {
  return (
    <div
      className={clsx(floating && style['container--floating'], style['container'])}
      data-testid="add-newbuildings-button"
    >
      <a className={style['link-area']} href={ADD_NEW_BUILDING_TO_COMPARE} onClick={onClick} target="blank" />
      {floating ? <IconActionPlus16 color="icon-main-default" /> : <IconActionPlus24 color="icon-main-default" />}
      <UIHeading4 color="text-main-default">Найти ещё</UIHeading4>
    </div>
  );
}
